// 全局默认配置项

// 登录地址
export const LOGIN_URL: string = '/login';

// 首页地址[默认]
export const HOME_URL: string = '/chat';

// 默认主题颜色
export const DEFAULT_THEME_COLOR: string = '#2992FF';

// 折叠阈值
export const COLLAPSE_THRESHOLD: number = 600;

// 左侧菜单宽度
export const SIDE_BAR_WIDTH: number = 232;

// 左侧菜单收起后的窄条宽度
export const SIDE_BAR_RAIL_WIDTH: number = 68;

/** 小程序 web-view 注入页：无 Pinia 会话，token 只在 URL hash 里传给子应用。 */
export const EMBED_BRIDGE_PATH = '/embed-bridge';

// 路由白名单地址[本地存在的路由 staticRouter.ts 中]
export const ROUTER_WHITE_LIST: string[] = [
  '/chat',
  '/chat/not_login',
  '/experts',
  '/resources',
  '/skills',
  '/connectors',
  '/automation',
  '/knowledge',
  '/403',
  '/404',
  '/login',
  '/notification',
  EMBED_BRIDGE_PATH,
];
